<template>
	<div class="flex flex-col">
		<teleport to="body">
			<div
				v-if="expanded"
				class="fixed z-50 overflow-hidden left-0 top-0 w-screen h-screen bg-white">
				<VPerfectSignature
					ref="signaturePad"
					:width="width"
					:height="height"
					:stroke-options="strokeOptions"
					data-testid="canvas" />

				<div class="flex w-full justify-between gap-3 absolute top-0 p-2">
					<app-button class="w-full" theme="outline" data-testid="clear" @click="clear"
						>Clear</app-button
					>
					<app-button class="w-full" data-testid="done" @click="close">Done</app-button>
				</div>
			</div>
		</teleport>

		<app-button theme="outline" data-testid="button" @click="expand">
			<app-icon :icon="['fas', 'fa-signature']" />
			Sign
		</app-button>
	</div>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import { VPerfectSignature } from 'v-perfect-signature'

	const signaturePad = ref()
	const strokeOptions = {
		size: 16,
		thinning: 0.75,
		smoothing: 0.5,
		streamline: 0.5
	}

	const expanded = ref(false)
	const width = ref(`${window.innerWidth}px`)
	const height = ref(`${window.innerHeight}px`)

	const expand = () => {
		expanded.value = true
		document.body.style.height = '100vh'
		document.body.style.overflow = 'hidden'
		resize()
		window.addEventListener('resize', resize)
	}

	const close = () => {
		const dataURL = signaturePad.value.toDataURL('image/png')
		expanded.value = false
		document.body.style.overflow = 'scroll'
		document.body.style.height = 'auto'
		window.removeEventListener('resize', resize)
		emit('stop-drawing', dataURL)
	}

	const clear = () => {
		signaturePad.value.clear()
		emit('clear')
	}

	const resize = async () => {
		width.value = `${window.innerWidth}px`
		height.value = `${window.innerHeight}px`

		if (signaturePad.value) {
			signaturePad.value.resizeCanvas(true)
			signaturePad.value.getCanvasElement().width = window.innerWidth
			signaturePad.value.getCanvasElement().height = window.innerHeight
		}
	}

	const emit = defineEmits(['stop-drawing', 'clear'])
</script>
